export default __webpack_public_path__ + "static/home_page_estimates-c0f25f75725fe2a0bf337650ce340452.mp4";